const fulldata = {
  2022: {
    // Nonbre de chantier à lier avec BDD
    chartChantier: [6, 15, 13, 41, 20, 33, 8, 2, 15, 16, 27, 4],
    // CA ne pas lié prévu pour une v2 mais ça fait jolie ^^
    chartChiffre: [5000, 8000, 20000, 50000, 10000, 7000],
    //à lié avec BDD
    chartJob: [
      //electricity
      4,
      //plomberie
      2,
      //Couverture
      1,
      //Maçonnerie
      5,
      //Menuiserie
      4,
      //Gros oeuvre
      8],
  },
  2021: {
    chartChantier: [4, 12, 11, 51, 10, 53, 2, 1, 11, 10, 7, 5],
    chartChiffre: [2000, 5000, 25000, 20000, 80000, 6000],
    chartJob: [
      //electricity
      10,
      //plomberie
      4,
      //Couverture
      8,
      //Maçonnerie
      4,
      //Menuiserie
      4,
      //Gros oeuvre
      5]
  },
  2020: {
    chartChantier: [4, 12, 11, 51, 10, 53, 2, 1, 11, 10, 7, 5],
    chartChiffre: [2000, 100, 5000, 15000, 80000, 6000],
    chartJob: [
      //electricity
      10,
      //plomberie
      3,
      //Couverture
      8,
      //Maçonnerie
      4,
      //Menuiserie
      4,
      //Gros oeuvre
      5]

  },
  2019: {
    chartChantier: [4, 16, 11, 51, 1, 5, 2, 1, 11, 10, 7, 5],
    chartChiffre: [2000, 1000, 5000, 10000, 80000, 6000],
    chartJob: [
      //electricity
      1,
      //plomberie
      4,
      //Couverture
      10,
      //Maçonnerie
      4,
      //Menuiserie
      4,
      //Gros oeuvre
      5]
  },
};

export default fulldata;
